
import { useEffect, useState } from 'react';
import { query, where, limit, getDocs } from 'firebase/firestore';
import { auth, doc, collection, db, onSnapshot } from '../../js/firebase.js';
import { FaCheck } from 'react-icons/fa';
import { AiOutlineUserAdd, AiOutlineCheck } from "react-icons/ai";
import { Tooltip } from "react-tooltip";
function Profilebanner({ username }) {

    const [user, setUser] = useState(null);
    const getUserByUsername = async () => {
        const userRef = query(collection(db, 'users'), where('username', '==', username), limit(1))
        const unsubscribe = onSnapshot(userRef, (querySnapshot) => {
            if (!querySnapshot.empty) {
                const docSnapshot = querySnapshot.docs[0]
                setUser(docSnapshot.data())
                console.log(querySnapshot.docs[0].data())
            } else {
                console.log('No such document!')
            }
        })
    }
    const [isFollowing, setIsFollowing] = useState(false);

    const handleFollowClick = () => {
        setIsFollowing(!isFollowing);
    };
    useEffect(() => {
        if (username) {
            getUserByUsername()
        }

    }, [username])
    return (
        <>
            {user && (

                <div className='grid grid-cols-1 md:grid-cols-1 gap-6'>
                    <div className='flex lg:col-span-1 items-center justify-between bg-white/40 rounded px-1 py-2'>
                        <div className='flex gap-2 items-center'>
                            <div className="w-[4rem] h-[4rem] relative">
                                <div className="avatar bg-white rounded-full w-16 h-16 flex items-center justify-center">
                                    <span style={{ fontSize: '0.55rem' }} className="text-black break-all">
                                        {username}
                                    </span>
                                </div>

                                <div className="absolute bottom-0 right-0">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-5 h-5 text-pink-500"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                                        />
                                    </svg>
                                </div>
                            </div>

                            <div className="mt-0">
                                <div className='flex'>
                                    <h2 className='text-lg text-white uppercase mb-0'>{username}</h2>
                                    {user.bluetick && ( <> 
                                    
                                        &nbsp; <img data-tooltip-id="my-tooltip"
                                               data-tooltip-content="💫Đối tác uy tín đã xác minh🎀 "
                                               data-tooltip-place="bottom"
                                               src="https://hust.media/img/icon/bluetick.gif" alt="Đã Xác Minh" style={{ height: '20px' }} />
                                           <Tooltip className="max-w-xs mx-auto mb-0 break-all" id="my-tooltip" />
                                    </>
                                    )}
                                
                                </div>



                                <p className='text-sm m-0'>{user.caption ? user.caption.toString() : ''}</p>
                                <p className='text-sm m-0'>Bảo hiểm: {user.baohiem ? user.baohiem.toString() : ''}</p>

                                <p className='text-sm m-0'>Follower:       {user.follower && (
                                    <>
                                        {user.follower}
                                    </>)}</p>

                            </div>
                        </div>

                        <div className='flex flex-col gap-2 mt-2 justify-around sm:justify-start'>
                            <div
                                className={`flex justify-center items-center px-2 py-1 border border-white rounded-sm grow sm:grow-0 cursor-pointer ${isFollowing ? 'following' : ''
                                    }`}
                                onClick={handleFollowClick}
                            >
                                {isFollowing ? (
                                    <>
                                        <AiOutlineCheck />
                                        <span className='text-sm'>Đã theo dõi</span>
                                    </>
                                ) : (
                                    <>
                                        <AiOutlineUserAdd />
                                        <span className='text-sm'>Theo dõi</span>
                                    </>
                                )}
                            </div>
                            <a href={user.lienket} style={{ textDecoration: 'none' }} target="_blank" >
                                <div className='flex justify-center items-center px-2 py-1 gap-1 border border-white rounded-sm grow sm:grow-0 cursor-pointer'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1.5}
                                        stroke='currentColor'
                                        className='w-4 h-4'>
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            d='M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155'
                                        />
                                    </svg>
                                    <div className='text-black no-underline text-sm'>
                                        Chat
                                    </div>
                                </div> </a>

                        </div>
                    </div>
                </div>
            )}

        </>
    )
}
export default Profilebanner
